/* @ngInject */
const sterileAsk = (
  utils,
  valueHandler,
  sterileLabels,
  sterileRequest,
  toaster,
  saleData
) => {
  const self = {}

  self.delete = async (_id, _back = false) => {
    if (valueHandler.isId(_id.id)) { _id = _id.id }

    if (toaster.confirm(sterileLabels.ask.delete)) {
      try {
        const message = await sterileRequest.delete(_id)
        toaster.message(message)
        utils.removeFromArray(saleData.mySale.steriles, _id)
        if (_back) {
          utils.$back()
        }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  return self
}
export default sterileAsk



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/services/ask.service.js